import { render, staticRenderFns } from "./HotelOffersTab.vue?vue&type=template&id=15c79d37&lang=pug&"
import script from "./HotelOffersTab.vue?vue&type=script&lang=ts&"
export * from "./HotelOffersTab.vue?vue&type=script&lang=ts&"
import style0 from "./HotelOffersTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports